var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0083 4.64707V13.1137C13.0083 13.4471 12.9083 13.7721 12.725 14.0471L10.45 17.4304C10.0916 17.9721 9.19997 18.3554 8.44163 18.0721C7.62497 17.7971 7.0833 16.8804 7.2583 16.0637L7.69163 13.3387C7.72497 13.0887 7.6583 12.8637 7.51663 12.6887C7.37497 12.5304 7.16663 12.4304 6.94163 12.4304H3.51663C2.8583 12.4304 2.29163 12.1637 1.9583 11.6971C1.64163 11.2471 1.5833 10.6637 1.79163 10.0721L3.84163 3.8304C4.09997 2.79707 5.22497 1.9554 6.34163 1.9554H9.59163C10.15 1.9554 10.9333 2.14707 11.2916 2.5054L12.3583 3.3304C12.7666 3.63873 13.0083 4.1304 13.0083 4.64707Z",
    fill: "#7D7E80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6584 14.7383H16.5167C17.8084 14.7383 18.3334 14.2383 18.3334 13.0049V4.62161C18.3334 3.38828 17.8084 2.88828 16.5167 2.88828H15.6584C14.3667 2.88828 13.8417 3.38828 13.8417 4.62161V13.0049C13.8417 14.2383 14.3667 14.7383 15.6584 14.7383Z",
    fill: "#7D7E80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownFilled);
export default __webpack_public_path__ + "static/media/ThumbsDownFilled.a6d40c22add842be6670a21ad81d29f5.svg";
export { ForwardRef as ReactComponent };